<template>
    <ul class="details-nav-type-1" v-if="visibleWidgets.length">
        <li 
            v-for="widget in visibleWidgets" 
            :key="widget.id"
            :class="[{ 'is-loading': widget.loading }, { 'is-unavailable': widget.unavailable }]"
        >
            <div class="name" @click="!widget.unavailable && navigateToWidget(widget.id)">{{ $t(widget.titleKey || widget.id) }}</div>
            <div class="status">
                <div v-if="widget.loading && !widget.loaded && !widget.unavailable" class="loading-spinner-type-1 primary"></div>
                <!-- <div v-if="!widget.loaded && !widget.loading" class="indicator not-loaded"></div> -->
                <!-- <div v-else-if="widget.toggle && !widget.loading" class="indicator open" @click="closeWidget(widget.id)"></div> -->
                <!-- <div v-else-if="widget.unavailable && !widget.loading" class="indicator unavailable"></div> -->
            </div>
            <div class="actions">
                <button v-if="widget.paywallActive" @click="$router.push({ name: 'subscriptions' })" class="btn-s-icon btn-6 set-default-toggle" v-tooltip="'tooltips.upgrade_subscription'">
                    <div class="icon-lock-pos"></div>
                </button>
                <button v-else class="btn-s-icon set-default-toggle" :class="getWidgetToggle(widget.id) ? 'btn-1' : 'btn-5'" @click="setWidgetToggle(widget.id, !getWidgetToggle(widget.id))" v-tooltip="'tooltips.widget_star'">
                    <div class="icon-star-pos"></div>
                </button>
                <button class="btn-5 btn-s-icon move-up" :disabled="isFirstWidget(widget.id)" @click="moveWidgetUp(widget.id)" v-tooltip="'tooltips.widget_up'">
                    <div class="icon-arrow-pos"></div>
                </button>
                <button class="btn-5 btn-s-icon move-down" :disabled="isLastWidget(widget.id)" @click="moveWidgetDown(widget.id)" v-tooltip="'tooltips.widget_down'">
                    <div class="icon-arrow-pos"></div>
                </button>
            </div>
        </li>
    </ul>
    <div class="details-nav-type-1-presets" v-if="presets.length">
        <div class="header">
            <div class="title">{{ $t("components.widget_presets.title") }}</div>
            <p class="description">{{ $t("components.widget_presets.description") }}</p>
        </div>
        <div class="buttons">
            <button
                v-for="preset in presets"
                :key="preset.id"
                class="link-tex"
                :class="activePresetId === preset.id ? 'btn-1' : 'btn-5'"
                @click="applyPreset(preset.id)"
            >{{ $t("components.widget_presets." + preset.id) }}</button>
        </div>
        <p class="warning">{{ $t("components.widget_presets.warning") }}</p>
    </div>
</template>

<script>
    import { useCompanyWidgetsStore } from '@/stores/companyWidgets';
    import { mapActions, mapState } from 'pinia';
    import { widgetPresets } from '@/data/widgetPresets';

    export default {
        name: "CompanyDetailsNav",
        computed: {
            presets() { return widgetPresets; },
            visibleWidgets() {
                return useCompanyWidgetsStore().getActiveWidgets();
            },
            ...mapState(useCompanyWidgetsStore, {
                activePresetId: store => store?.options?.activePresetId || null,
            }),
        },
        methods: {
            ...mapActions(useCompanyWidgetsStore, [
                'navigateToWidget',
                'closeWidget',
                'moveWidgetUp',
                'moveWidgetDown',
                'setWidgetToggle',
                'getWidgetToggle',
                'applyPreset',
            ]),
            isFirstWidget(id) {
                const visibles = this.visibleWidgets.filter(w => !w.unavailable);
                if (!visibles.length) return false;
                return visibles[0].id === id;
            },
            isLastWidget(id) {
                const visibles = this.visibleWidgets.filter(w => !w.unavailable);
                if (!visibles.length) return false;
                return visibles[visibles.length - 1].id === id;
            }
        }
    }
</script>